<script>
    import {Link} from "svelte-routing";
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_AddBtn from '../components/TopMenu_AddBtn.svelte';
    import ImageCDN from '../components/ImageCDN.svelte';
    import Loading from '../components/Loading.svelte';
    import {api, store} from '../stores.js';
    import Image from '../components/Image.svelte';
    
    const user = store('credentials', 'appUserAuth');
    
    const fetchAllEvents = (async () => {
        let result = await api('getRegPredEvents', {login: $user.email, password: $user.pasport});
        return result.data ? result.data : [];
    })();
</script>

<TopMenu title="Список мероприятий">
    <TopMenu_AddBtn slot="right" href="/activity/add" />
</TopMenu>

<div id="appCapsule">
    {#await fetchAllEvents}
        <Loading />
    {:then data}
        <div class="section">
            <div class="row">
                {#each data as {id, otherScan, name, produktName, datePlan, timePlan, adres, price, komment}, i}
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="card my-2 mx-0">
                            <Link to="/activity/view/{id}">
                                {#if otherScan}
                                    <ImageCDN src="{otherScan}" class="card-img-top" alt="{produktName}" style="height: 300px;object-fit: cover;object-position: center center;" />
                                {:else}
                                    <Image src="/img/event.jpg" class="card-img-top" alt="{produktName}" style="height: 300px;object-fit: cover;object-position: center center;" />
                                {/if}
                            </Link>
                            <div class="card-body">
                                <h3>{produktName}</h3>
                                <h6 class="card-subtitle mb-2 text-muted">{price > 0 ? ((+price).toFixed(2)) + ' |' : '' } {datePlan} {timePlan}</h6>
                                <p class="card-text">{@html name}</p>
                                <p class="card-text">{@html adres}</p>
                            </div>
                            <div class="card-footer">
                                <Link to="/activity/view/{id}" class="btn btn-primary btn-block">Просмотр и управление</Link>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    {/await}
</div>
